const FALLBACK_FORMATTING_LOCALE = "de-DE"

// The formatting locale is deliberately independent of the content language: a
// French visitor reading the German site should still get French number and date
// formats. Words stay with getContentLanguage().
export function getFormattingLocale(override?: string): string {
  const candidate =
    override ||
    (typeof navigator !== "undefined" ? navigator.language : undefined)

  if (!candidate) {
    return FALLBACK_FORMATTING_LOCALE
  }

  // Some clients report a locale Intl rejects (underscores, comma-separated
  // lists, empty strings), which makes every Intl construction throw a
  // RangeError.
  try {
    Intl.NumberFormat.supportedLocalesOf(candidate)
    return candidate
  } catch {
    return FALLBACK_FORMATTING_LOCALE
  }
}
